parseDirectiveLocation